import { isApiError } from './api'

/** A frase do erro, pronta para o `ActionError`: a da API, ou a genérica com causa e caminho. */
export function errorMessage(error: unknown): string {
  if (isApiError(error)) return error.message
  return 'Algo falhou do nosso lado. Tente de novo em instantes.'
}

/** Os erros por campo de um 422, para pôr embaixo de cada campo. */
export function fieldErrors(error: unknown): Record<string, string> {
  return isApiError(error) ? error.fields : {}
}

/** O id da requisição, para quem for reportar o problema. */
export function errorRequestId(error: unknown): string | null {
  return isApiError(error) ? error.requestId : null
}
